// extracted by mini-css-extract-plugin
export default {"fieldAmount":"styles_fieldAmount__OjQ2g","fieldDistribution":"styles_fieldDistribution__je89G","contentSubmit":"styles_contentSubmit__4k6B2"};